var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "d-flex align-items-center justify-content-between dropdown-item p-t-10 p-b-10 flex-wrap",
      attrs: { title: _vm.preset.name },
    },
    [
      !_vm.patchPresetInit
        ? _c(
            "span",
            {
              staticClass: "vue-preset-selector-preset-name",
              attrs: { id: "presetName" },
            },
            [_vm._v(_vm._s(_vm._f("truncate")(_vm.preset.name)))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.patchPresetInit
        ? _c("form", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.updatePresetName,
                  expression: "updatePresetName",
                },
              ],
              staticClass: "form-control",
              attrs: {
                placeholder: _vm._f("truncate")(_vm.preset.name),
                id: "patchPresetInput",
              },
              domProps: { value: _vm.updatePresetName },
              on: {
                change: function ($event) {
                  return _vm.$emit("change-preset-name", _vm.updatePresetName)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.updatePresetName = $event.target.value
                },
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-wrap" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-success mr-1 my-2",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.$emit("select-preset", _vm.preset)
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-right" }),
            _vm._v(" "),
            _c("span", { staticClass: "preset-btn-text" }, [
              _vm._v(_vm._s(_vm._f("trans")("Select"))),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-info mr-1 my-2",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                _vm.$emit("update-preset", _vm.preset)
                _vm.initPatchPreset(_vm.preset)
              },
            },
          },
          [
            _c("i", {
              class: {
                "fa fa-pen": !_vm.patchPresetInit,
                "fa fa-arrow-left": _vm.patchPresetInit,
              },
            }),
            _vm._v(" "),
            !_vm.patchPresetInit
              ? _c("span", { staticClass: "preset-btn-text" }, [
                  _vm._v(_vm._s(_vm._f("trans")("Edit"))),
                ])
              : _c("span", { staticClass: "preset-btn-text" }, [
                  _vm._v(_vm._s(_vm._f("trans")("Back"))),
                ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-danger my-2",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.$emit("delete-preset", _vm.preset)
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-trash" }),
            _vm._v(" "),
            _c("span", { staticClass: "preset-btn-text" }, [
              _vm._v(_vm._s(_vm._f("trans")("Delete"))),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }